import {AuthConfigService, AuthHttpHeaderService, AuthInterceptor} from '@spartacus/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {Observable, of} from 'rxjs';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';

@Injectable({providedIn: 'root'})
export class DcpAuthInterceptor extends AuthInterceptor implements HttpInterceptor {
  constructor(
    protected authHttpHeaderService: AuthHttpHeaderService,
    protected authConfigService: AuthConfigService,
    protected authService: DcpAuthService,
    protected oAuthService: OAuthService
  ) {
    super(authHttpHeaderService, authConfigService);
  }

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      this.oAuthService.getAccessToken()
      && !this.oAuthService.hasValidAccessToken()
    ) {
      this.authService.coreLogout().then(() => {
        this.authService.login();
        return of();
      });
    }

    return super.intercept(httpRequest, next);
  }

  protected isExpiredToken(resp: HttpErrorResponse): boolean {
    return resp.error?.errors?.[0]?.type === 'InvalidTokenError' || resp.error?.errors?.[0]?.type === 'InvalidBearerTokenError';
  }
}
